import { useQuery } from '@tanstack/react-query';

import { validateRequestProjectSubmissionLink } from '@/api/v4/request-project.api';
import { QueryKey } from '@/config/query-client';

export const useValidateRequestProjectSubmissionLink = (linkId: string) => {
  return useQuery({
    queryKey: [QueryKey.RequestProjectSubmissionLink, 'validate', linkId],
    queryFn: () => validateRequestProjectSubmissionLink({ linkId }),
    enabled: !!linkId,
    retry: false,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
  });
};
